<template>
  <button class="btn btn-outline-secondary" @click="goBack()"><font-awesome-icon icon="chevron-left" /> Zurück</button>

  <div v-if="vertragspartner == null" class="alert alert-danger mt-5">Ungültige Vertragspartner ID: {{ vertragspartnerid }}</div>

  <div v-else>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h1 class="fs-2 mb-0">{{ vertragspartner.unternehmen }}</h1>
        <p class="fs-5 text-secondary">{{ vertragspartner.unternehmenzusatz }}</p>
      </div>

      <router-link v-if="store.getters.isAdmin" :to="{ name: 'EditVertragspartner', query: { vertragspartnerid: vertragspartnerid } }" class="btn">
        <font-awesome-icon icon="pen" />
      </router-link>
    </div>

    <div class="row mx-0">
      <div class="col-4 p-2 ps-0">
        <div class="bg-white shadow rounded p-3 pe-4 h-100">
          <div class="row mx-0 mb-2">
            <div class="col-4 p-0 fw-bold">Ansprechpartner:</div>

            <div class="col p-0">{{ vertragspartner.anrede }} {{ vertragspartner.vorname }} {{ vertragspartner.name }}</div>
          </div>

          <div class="row mx-0 mb-2">
            <div class="col-4 p-0 fw-bold">Standort:</div>

            <div class="col p-0">{{ vertragspartner.standort }}</div>
          </div>

          <div class="row mx-0 mb-2">
            <div class="col-4 p-0 fw-bold">Tarifgebiet:</div>

            <div class="col p-0">{{ vertragspartner.tarifgebiet }}</div>
          </div>

          <div class="row mx-0 mb-2">
            <div class="col-4 p-0 fw-bold">HRBP Standard:</div>

            <div class="col p-0">{{ vertragspartner.hrbpStandard }}</div>
          </div>

          <div class="row mx-0 mb-2">
            <div class="col-4 p-0 fw-bold">AU Vorlage:</div>

            <div class="col p-0">{{ vertragspartner.auVorlage }}</div>
          </div>
        </div>
      </div>

      <div class="col-4 p-2">
        <div class="bg-white shadow rounded p-3 pe-4 h-100">
          <p><strong>Anschrift</strong></p>

          <p>
            {{ vertragspartner.unternehmen }}<br />
            {{ vertragspartner.unternehmenzusatz }}<br />
            {{ vertragspartner.anrede }} {{ vertragspartner.vorname }} {{ vertragspartner.name }}<br />
            {{ vertragspartner.strasse }}<br />
            {{ vertragspartner.plz }} {{ vertragspartner.ort }}<br />
            {{ vertragspartner.land }}
          </p>
        </div>
      </div>

      <div class="col-4 p-2 pe-0">
        <div class="bg-white shadow rounded p-3 pe-4 h-100">
          <p><strong>Notizen</strong></p>
          <p>{{ vertragspartner.notizen }}</p>
        </div>
      </div>
    </div>

    <div class="row mx-0 mb-3">
      <div class="col-4 p-2">
        <div class="bg-white shadow rounded p-3 h-100">
          <div class="mb-3">
            <p class="fw-bold mb-1">Kündigungsfrist während der Probezeit (Deutsch):</p>
            <p>{{ vertragspartner.kfWaerendProbezeit }}</p>
          </div>

          <div class="mb-3">
            <p class="fw-bold mb-1">Kündigungsfrist während der Probezeit (Englisch):</p>
            <p>{{ vertragspartner.kfWaerendProbezeitEN }}</p>
          </div>
        </div>
      </div>

      <div class="col-4 p-2 pe-0">
        <div class="bg-white shadow rounded p-3 h-100">
          <div class="mb-3">
            <p class="fw-bold mb-1">Kündigungsfrist nach der Probezeit (Deutsch):</p>
            <p>{{ vertragspartner.kfNachProbezeit }}</p>
          </div>

          <div class="mb-3">
            <p class="fw-bold mb-1">Kündigungsfrist nach der Probezeit (Englisch):</p>
            <p>{{ vertragspartner.kfNachProbezeitEN }}</p>
          </div>
        </div>
      </div>

      <div class="col-4 p-2 pe-0">
        <div class="bg-white shadow rounded p-3 h-100">
          <p class="fw-bold mb-1">Druckvorlagen:</p>
          <div v-if="vertragspartner.druckvorlagen == undefined || vertragspartner.druckvorlagen.length == 0"><em>Keine Druckvorlagen zugewiesen.</em></div>
          <div v-else>
            <p v-for="vorlage in vertragspartner.druckvorlagen" :key="vorlage.id">{{ getDruckvorlageName(vorlage.druckvorlageId) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, PropType, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';

  import { ActionTypes as DruckvorlageActionTypes } from '@/store/modules/Druckvorlagen/actions';

  import { Vertragspartner } from '@/models/VertragspartnerModels';
  //#endregion

  const props = defineProps({
    vertragspartnerid: {
      type: String as PropType<string>,
      required: true,
    },
  });

  const store = useStore();
  const router = useRouter();

  const vertragspartner = computed(() => store.getters.vertragspartner.find((v: Vertragspartner) => v.id == parseInt(props.vertragspartnerid)));

  const druckvorlagen = computed(() => store.getters.druckvorlagen);

  function getDruckvorlageName(id: number): string {
    const druckvorlage = druckvorlagen.value.find((d: any) => d.id == id);
    return druckvorlage != null ? druckvorlage.titel : 'Unbekannte Druckvorlage';
  }

  function goBack() {
    router.push({ name: 'Vertragspartner' });
  }

  onMounted(async () => {
    if (druckvorlagen.value.length == 0) {
      await store.dispatch(DruckvorlageActionTypes.GetDruckvorlagen, undefined);
    }
  });
</script>
